import { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { usePageContext } from '@hero/web-context';
import { ContactTableManager } from '@hero/web-components';

/**
 * Standalone org-wide contacts surface mounted under `/more/contacts`.
 * Reuses `ContactTableManager`, which mounts its own
 * Contact/Client/SavedLocation/Order drawers when `renderDrawers={true}`.
 */
export default function ContactsPage() {
  const { t } = useTranslation(['m-contact', 'applications']);
  const { setPageName } = usePageContext();

  useEffect(() => {
    setPageName(t('applications:Contacts.title', { defaultValue: 'Contacts' }));
  }, [setPageName, t]);

  return (
    <div className="mt-6">
      <ContactTableManager displayForUser="carrier" renderDrawers={false} redirect />
    </div>
  );
}
